import { n as cx } from "./primitives-DLlUP8hy.js";
import { l as fieldStyles } from "./field-DFMGDdxo.js";
import { jsx } from "react/jsx-runtime";
import { TextField } from "react-aria-components";
var TextField$1 = ({ className: i,...a }) => /* @__PURE__ */ jsx(TextField, {
	"data-slot": "control",
	className: cx(fieldStyles(), i),
	...a
});
export { TextField$1 as t };
